import React, { useState, Suspense } from "react";
import { useInView } from "react-intersection-observer";

/* card components */
import ExpandableDefinition from "./ExpandableDefinition";
import DefinitionCard from "./DefinitionCard";

/* styles */
import "/styles/modern-normalize.css";
import "/styles/global.css";
import "/styles/components/cover.css";
import "/styles/components/main.css";
import "/styles/components/expandcontent.css";
import "/styles/components/reference.css";
import "/styles/utility.css";

export default function Reference() {
  return (
    <main>
      {/* section: title */}
      <section id="cover" className="story container">
        <h1 className="cover__title"> WateryTrees </h1>
        <h2 className="cover__subtitle"> The Sponge, 2039 References</h2>
        <h2 className="cover__author">Story and art by Saachi Sadcha</h2>
      </section>
      {/* section: Prologue2039 */}
      <section id="prologue" className="story container section">
        <h3 className="chapter__subtitle">Prologue</h3>
        <h2 className="chapter__title-year"> 2039</h2>
        <ul className="reference__list">
          <li> "WateryTrees declared a food shortage emergency"</li>
          <li> "the wetlands are largely restored"</li>
          <li> "circular economy"</li>
          <li> "food desert turned into a food oasis"</li>
        </ul>
      </section>

      {/* section: Editor’s Note + Introduction */}
      <section id="intro" className="story container section">
        <h3 className="chapter__subtitle">Editor’s Note</h3>
        <h2 className="chapter__title-year">Introduction</h2>
        <ul className="reference__list">
          <li> "Lakeshore District"</li>
          <li> "WateryTrees"</li>
        </ul>
      </section>

      {/* section: Disclaimer */}
      <section id="disclaimer" className="story container section">
        <h2 className="chapter__title">Disclaimer</h2>
        <ul className="reference__list">
          <li> "speculative fiction"</li>
        </ul>
      </section>

      {/* section: 2020-2024 */}
      <section id="2020-2024" className="story container section">
        <h3 className="chapter__subtitle">Rosa</h3>
        <h2 className="chapter__title-year">2020-2024</h2>
        <ul className="reference__list">
          <li> "community rain gardens"</li>
          <li> "white paint on the roofs and streets"</li>
          <li> "dataviz on ingredient impact"</li>
          <li> "fancy living pergolas"</li>
          <li> "after rent, we had to choose between hydro or food"</li>
        </ul>
      </section>

      {/* section: 2025 - 2029 */}
      <section id="2025-2029" className="story container section">
        <h3 className="chapter__subtitle">Orson</h3>
        <h2 className="chapter__title-year">2025 - 2029</h2>
        <ul className="reference__list">
          <li> "floods we’re predicted to get in 50 years"</li>
          <li> "Terminal flooded"</li>
          <li> "vertical gardens"</li>
          <li> "dataviz who's more likely to require the food bank"</li>
          <li> "EcoSafe program"</li>
          <li> "social enterprise"</li>
          <li> "niche-intelligence"</li>
        </ul>
      </section>

      {/* section: 2030-2034 */}
      <section id="2030-2034" className="story container section">
        <h3 className="chapter__subtitle">Indra</h3>
        <h2 className="chapter__title-year"> 2030 - 2034</h2>
        <ul className="reference__list">
          <li> "the Sponge's many rivers and creeks"</li>
          <li> "eastern suburbs near the Greenbelt"</li>
          <li> "micro urban farms"</li>
          <li> "biomimicry"</li>
          <li> "Dataviz on food life cycle information availability"</li>
          <li> "how much energy and water that deer likely consumed"</li>
          <li> "Grow Market"</li>
          <li> "repurposed into housing and vertical gardens"</li>
        </ul>
      </section>

      {/* section: 2035-2039 */}
      <section id="2035-2039" className="story container section">
        <h3 className="chapter__subtitle">Janey</h3>
        <h2 className="chapter__title-year"> 2035 - 2039</h2>
        <ul className="reference__list">
          <li> "Stewardship"</li>
          <li> "the Elders"</li>
          <li> "Food Systems Education"</li>
          <li> "Visitors are actively encouraged to forage here"</li>
          <li> "Dataviz qualitative viz on Sponge resource and services"</li>
        </ul>
      </section>

      {/* section: Afterword2039 */}
      <section id="afterword" className="story container section">
        <h3 className="chapter__subtitle">Afterword</h3>
        <h2 className="chapter__title-year">2039</h2>
        <ul className="reference__list">
          <li> "Pumpkinseed, Walleye, Salmon, Pike"</li>
        </ul>
      </section>

      {/* section: Footer */}
      <section id="footer" className="story container section">
        <p className="reference__list">
          ~ Copyright © 2025 Saachi Sadcha - All Rights Reserved. ~
          <br />
          All images, 3D models, and content are original, and created by Saachi
          Sadchatheeswaran. Do not copy, download or sell.
        </p>
        <p className="reference__list"></p>
      </section>
    </main>
  );
}
